import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Row,
  Spin,
  Statistic,
  Tag,
  Typography,
} from "antd";
import {
  SafetyOutlined,
  EditOutlined,
  SettingOutlined,
  DislikeOutlined,
} from "@ant-design/icons";

import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../contractBooking/contractbooking.config";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { rightAction } from "../../../../redux/actions";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import "../../../../assets/styles/InterbankPlacement.css";
import bondData from "../../component/data/bond.json";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { handleFlgStatus } from "../../../../components/facilities/AccountFacility";
import {
  AccountFacility,
  handleBondContractActionButtons,
} from "../../../../components/facilities/TreasuryFacility";
import TransactionsTab from "./components/TransactionsTab";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const ViewBond = (props) => {
  const { userData } = props;
  const { session } = userData;
  const [activeKey, setActiveKey] = useState(["1"]);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [bondDetails, setBondDetails] = useState([]);
  const [prodDetails, setProdDetails] = useState([]);
  const [productId, setProductId] = useState(null);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [entityId, setEntityId] = useState(null);
  const [addressDetails, setAddressDetails] = useState([]);
  const [kycDetails, setKycDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [menuProps, setMenuProps] = useState({ items: [] });
  const [activeTabKey, setActiveTabKey] = useState("transactions");
  const [transactionsList, setTransactionsList] = useState([]);
  const [showInterestChecked, setShowInterestChecked] = useState(false);

  const formatFullDate = (date) => {
    if (!date || date === "--") return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const tabList = [
    {
      key: "transactions",
      label: "Transactions",
    },
    // {
    //   key: "charges",
    //   label: "Charges",
    //   disabled: !BOM.HasPermission("READ_SAVINGSACCOUNTCHARGE"),
    // },
  ];

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  const getBondContractById = () => {
    const url = `${apiConfig.GetBondContract}/${state?.id}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setBondDetails(objDetail);
        setMenuProps({
          items: handleBondContractActionButtons(objDetail, prodDetails),
          onClick: (e) => {
            const item = handleBondContractActionButtons(
              objDetail,
              prodDetails
            ).find((element) => element.key === e.key);
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "close deal":
                  return closeContract();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      actionLabel: item.label,
                      contractObj: objDetail,
                    },
                  });
              }
            }
          },
        });
        setEntityId(objDetail?.client?.id);
        setProductId(objDetail?.product?.id);
        setIsLoading(false);
      }
    });
  };

  const getBondById = (prodId) => {
    const url = `${apiConfig.GetBondProduct}/${prodId}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setProdDetails(objDetail);
        setIsLoading(false);
      }
    });
  };

  const getCustomerDetailById = (param) => {
    const url = `${apiConfig.Clients}/${param}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setCustomerDetails(objDetail);
        setIsLoading(false);
      }
    });
  };

  const getAddresses = (param) => {
    const url = `${apiConfig.Client}/${param}/addresses`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        const addressObj = objDetail[0];
        setAddressDetails(objDetail[0]);
        setIsLoading(false);
      }
    });
  };

  const getKycInfo = () => {
    const url = `${apiConfig.Clients}/template?staffInSelectedOfficeOnly=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        setKycDetails(objList);
      }
    });
  };

  const getTransactionDetailById = (params) => {
    const url = `${apiConfig.GetBondContracts}/${params.id}/transactions`;

    let body = {
      session,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // setAccountDetails(objDetail);

        let tempChargesArray = [];
        let tempTransactionsArray = [];

        objDetail?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.dateOf
              ? BOM.DateTime(element?.dateOf, "only-date")
              : "-",
            transactionType: element?.transactionType
              ? element?.transactionType?.value?.replace("actionType.", "")
              : "-",
            transactionRef: element?.refNo ? element?.refNo : "-",
            amount:
              element?.amount && element?.amount !== 0
                ? Number(element?.amount).toLocaleString()
                : "-",
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
            transactionTypeDetail: element.transactionType,
          });
        });

        // setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);

        setIsLoading(false);
      }
    });
  };

  const contentListNoTitle = {
    transactions: (
      <TransactionsTab
        transactionsList={transactionsList}
        state={state}
        userData={userData}
        showInterestChecked={showInterestChecked}
        setShowInterestChecked={setShowInterestChecked}
      />
    ),
    // charges: <div>Charges</div>,
  };

  useEffect(() => {
    if (!prodDetails) return;

    getBondContractById();
    getKycInfo();
  }, [prodDetails]);

  useEffect(() => {
    if (!productId) return;

    getBondById(productId);
  }, [productId]);

  useEffect(() => {
    if (!entityId) return;

    getCustomerDetailById(entityId);
    getAddresses(entityId);
    getTransactionDetailById(state);
  }, [entityId, state]);

  const transformedData = [
    {
      section: "Investor Information",
      items: [
        {
          name: "Investor Name",
          value: bondDetails?.client?.displayName
            ? bondDetails?.client?.displayName
            : "-",
        },
        {
          name: "Investor Type",
          value: bondDetails?.investorType?.text
            ? bondDetails?.investorType?.text
            : "-",
          isTag: true,
        },
        {
          name: "Contact Address",
          value: addressDetails?.addressLine1
            ? addressDetails?.addressLine1
            : "-",
        },
        {
          name: "City",
          value: addressDetails?.city ? addressDetails?.city : "-",
        },
        {
          name: "Phone Number",
          value: customerDetails?.mobileNo ? customerDetails?.mobileNo : "-",
        },
        {
          name: "Email",
          value: customerDetails?.emailAddress
            ? customerDetails?.emailAddress
            : "-",
        },
        {
          name: "BVN",
          value: kycDetails?.bvn ? kycDetails?.bvn : "-",
        },
        {
          name: "TIN",
          value: kycDetails?.tin ? kycDetails?.tin : "-",
        },
      ],
    },
    {
      section: "Bond Details",
      items: [
        {
          name: "Bond Product Name",
          value: bondDetails?.product?.productName
            ? bondDetails?.product?.productName
            : "-",
          isTag: true,
        },
        {
          name: "Deal Initation Date",
          value: bondDetails?.dealInitiationDate
            ? formatFullDate(bondDetails?.dealInitiationDate)
            : "-",
        },
        {
          name: "Branch Code",
          value: userData ? userData?.officeName : "-",
        },
        {
          name: "Initiated By",
          value: userData ? userData?.username : "-",
        },
        {
          name: "User ID",
          value: bondDetails ? userData?.userId : "-",
        },
        {
          name: "Bond Type",
          value: bondDetails?.bondType ? bondDetails?.bondType?.text : "-",
          isTag: true,
        },
        {
          name: "Issuer",
          value: bondDetails?.issuer ? bondDetails?.issuer : "-",
        },
        {
          name: "Issue Date",
          value: bondDetails?.issueDate
            ? formatFullDate(bondDetails?.issueDate)
            : "-",
        },
        {
          name: "Tenor",
          value: bondDetails?.tenor ? bondDetails?.tenor : "-",
        },
        // {
        //   name: "Coupon Rate",
        //   value: bondDetails?.couponRate ? bondDetails?.couponRate : "-",
        // },
        // {
        //   name: "Coupon Payment Frequency",
        //   value: bondDetails?.couponFrequency
        //     ? bondDetails?.couponFrequency
        //     : "-",
        // },
        {
          name: "Currency",
          value: bondDetails?.currency ? bondDetails?.currency?.code : "-",
        },
        {
          name: "Custodian",
          value: bondDetails?.custodian ? bondDetails?.custodian?.name : "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Investment Details",
      items: [
        {
          name: "Investor Amount",
          value: bondDetails?.amount
            ? bondDetails?.amount.toLocaleString()
            : "-",
        },
        {
          name: "Purchase Price",
          value: bondDetails?.purchasePrice
            ? bondDetails?.purchasePrice.toLocaleString()
            : "-",
        },
        {
          name: "Number of Units Purchased",
          value: bondDetails?.numberOfUnits
            ? bondDetails?.numberOfUnits.toLocaleString()
            : "-",
        },
        {
          name: "Total Consideration",
          value: bondDetails?.totalConsideration
            ? bondDetails?.totalConsideration.toLocaleString()
            : "-",
        },
        {
          name: "Settlement Date",
          value: bondDetails?.settlementDate
            ? formatFullDate(bondDetails?.settlementDate)
            : "-",
        },
        {
          name: "Settlement Account Number",
          value: bondDetails?.settlementAccount
            ? `${bondDetails?.settlementAccount?.depositType?.value} - ${bondDetails?.settlementAccount?.accountNo}`
            : "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Compliance Checks",
      items: [
        {
          name: "KYC Status",
          value: bondDetails?.kycStatus ? bondDetails.kycStatus?.text : "-",
          isTag: true,
        },
        {
          name: "AML Screening",
          value: bondDetails?.amlScreening
            ? bondDetails.amlScreening?.text
            : "-",
          isTag: true,
        },
        {
          name: "Sanctions Screening",
          value: bondDetails?.sanctionScreening
            ? bondDetails.sanctionScreening?.text
            : "-",
          isTag: true,
        },
        {
          name: "Central Bank Reporting Requirements",
          value: bondDetails?.centralBankReport
            ? bondDetails.centralBankReport?.text
            : "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Document Requirements",
      items: [
        {
          name: "Investor's Application Form",
          value: bondDetails?.applicationFormStatus
            ? bondDetails?.applicationFormStatus?.text
            : "-",
          isTag: true,
        },
        {
          name: "Executed Bond Purchase Agreement",
          value: bondDetails?.bondPurchaseAgreement
            ? bondDetails?.bondPurchaseAgreement?.text
            : "-",
          isTag: true,
        },
        {
          name: "Identification Documents",
          value: bondDetails?.identificationDocuments
            ? bondDetails?.identificationDocuments?.text
            : "-",
          isTag: true,
        },
        {
          name: "Corporate Resolution",
          value: bondDetails?.corporateResolution
            ? bondDetails?.corporateResolution?.text
            : "-",
          isTag: true,
        },
        {
          name: "Tax Clearance Certificate",
          value: bondDetails?.taxClearanceCertificate
            ? bondDetails?.taxClearanceCertificate?.text
            : "-",
          isTag: true,
        },
      ],
    },
  ];

  const dummyMenuItems = {
    items: [
      {
        label: "Modify Application",
        key: "1",
        route: "/savings-account-action",
        disabled: true,
        icon: <EditOutlined />,
      },
      {
        label: "Approve",
        key: "2",
        route: "/savings-account-action",
        disabled: true,
        icon: <SafetyOutlined />,
      },
      {
        label: "Reject",
        key: "3",
        route: "/savings-account-action",
        disabled: true,
        icon: <DislikeOutlined />,
      },
    ],
  };

  function closeContract() {
    console.log("Closing..");
  }

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === "--" ||
      value === null ||
      value === undefined ||
      value === "" ||
      value === "__"
    ) {
      return <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>;
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem = index === (bondDetails[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 1,
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>
                        {fieldGroup.name?.toLowerCase() === "email"
                          ? subField.value?.toLowerCase()
                          : subField.value}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  return (
    <MainLayout pageItems={staticConfig.viewContractBookingBond}>
      <TopContent
        pageTitle={labelConfig.contractBookingBond}
        createPageTitle={labelConfig.viewContractBookingBond}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>

              {/* <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 12,
                    paddingBottom: 12,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 24, backgroundColor: "#EAE7EC" }}
                >
                  <Row>
                    <Col span={12}>
                      <Statistic
                        title={"Customer Name"}
                        value={bondDetails?.client?.displayName ?? "-"}
                        valueStyle={{
                          fontSize: "16px",
                        }}
                      />
                      <Statistic
                        title={"Contract ID"}
                        value={bondDetails?.contractReferenceId || "---"}
                        valueStyle={{
                          fontSize: "16px",
                        }}
                      />
                    </Col>
                    <Col span={12}>
                      {bondDetails?.status?.text
                        ? handleFlgStatus(
                            bondDetails?.status?.text,
                            {
                              fontSize: 16,
                            },
                            false
                          )
                        : "-"}
                    </Col>
                  </Row>
                </Card>
              </Col> */}
            </Row>

            <AccountFacility
              status={bondDetails?.status?.text}
              name={bondDetails?.client?.displayName}
              id={bondDetails?.contractReferenceId}
              amount={bondDetails?.amount}
              interest={bondDetails?.totalInterestAccrued}
              currencyCode={bondDetails?.currency?.code}
              interestPerAnnum={bondDetails?.nominalAnnualInterestRate}
              // maturityDate={maturityDate}
            />

            <Row
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {transformedData?.map((section, index) => (
                <Col key={index}>
                  <Collapse
                    className="custom-collapse"
                    expandIcon={<ChevronDown color="red" />}
                    style={{
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                  >
                    <Panel
                      key={index + 1}
                      header={
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        >
                          {section.section}
                        </span>
                      }
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {section?.items?.map((item, itemIndex) =>
                          renderRow(item, itemIndex, index)
                        )}
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        </Card>

        <Card
          className="custom-transaction-tab"
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ViewBond);
